<template>
  <div>
    <chartLoaders v-if="showLoaders == true"></chartLoaders>
    <screen-loader v-if="showLoaders == true"></screen-loader>
    <v-card-text v-else-if="serverItems.length > 0 && showLoaders == false">
      <div class="chart-wrap" v-if="hasStepPressure">
        <div v-for="(variable, index) in variables" :key="index" class="chart-column">
          <div :ref="`chart-${index}`" class="main-chart">
          </div>

          <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div composition">>
            <v-card class="position-relative">
              <!-- <div class="modal-header header-div">
                <v-spacer></v-spacer>
                <v-btn @click="closeModal(index)" flat icon class="chart-preview-close-btn" size="x-small">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div> -->
              <v-card-text>
                <div class="d-flex align-center justify-space-between">
                  <h6>{{ getHeaderDisplayNameChartTitle(variable) }}</h6>
                  <v-btn @click="closeModal(index)" flat icon class="chart-preview-close-btn" size="x-small">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div :ref="`modal-chart-${index}`" class="modal-chart-container"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-else-if="!hasStepPressure" class="text-center py-3">
        <h4>Charts couldn't be plotted as step pressure is not available in this test.</h4>
      </div>
      <div class="table-wrap">
        <div class="text-right" v-if="serverItems.length > 0">
          <v-tooltip text="Download CSV">
            <template v-slot:activator="{ props }">
              <v-img class="pointer" v-bind="props" :src="documentDownload" alt="csv download"
                @click="downloadTableCSV"></v-img>
            </template>
          </v-tooltip>
        </div>
        <v-data-table :headers="headers" :items="serverItems" :total-items="totalItems" :items-per-page="itemsPerPage"
          :loading="loading" :search="search" :item-value="name" virtual-items>
          <template v-slot:headers>
            <tr class="main-header">
              <th v-for="(header, index) in headers" :key="index">
                {{ header.name }}
              </th>
            </tr>
            <tr class="sub-header">
              <th v-for="(header, index) in headers" :key="index">
                {{ header.unit }}
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td v-for="(header, index) in headers" :key="index">
                {{ displayValue(header.key, item[header.key]) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <div v-else-if="serverItems.length === 0 && showLoaders == false" class="tabs-no-test-div">
      <h4>No data available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import ChartLoaders from "../Loaders/ChartLoaders.vue";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import axios from "axios";
import { mapActions } from "vuex";

import downloadIcon from '../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../assets/Svg/camIcon.svg';
import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
import { mapGetters } from "vuex";
import { chartGridColor } from "@/utils/chartTheme";
import { downloadPlotlyAsPng } from "@/utils/plotlyPngDownload";
import { getTenantPrefix } from "@/utils/tenant";

export default {
  name: "CvdGasProperties",
  components: {
    ChartLoaders,
    ScreenLoader
  },
  data: () => ({
    expandIcon: require("../../../assets/Svg/Chart/expand-btn.svg"),
    documentDownload: require("../../../assets/Images/csv.svg"),
    itemsPerPage: 10,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    variables: ["1", "2"],
    isPreviewOpen: Array().fill(false),
    chartData: Array().fill(null),
    cachedData: {},
    testID: "",
    testName: "",
    sampleID: "",
    hasStepPressure: false,
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    showLoaders: true,
  }),
  computed: {
    tenantId() {
      return getTenantPrefix() || "";
    },
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  methods: {
    ...mapActions("metaData", ["getDisplayName"]),
    async loadItems() {
      var sampleId = this.$route.params.sampleId;
      var cvdId = this.$route.params.id;
      this.loading = true;
      this.showLoaders = true;

      try {
        let response = await axios.get(
          process.env.VUE_APP_API_URL +
          `public/api/samples/${sampleId}/cvdtests/${cvdId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": this.tenantId,
            },
          }
        );

        this.serverItems = response.data.data.cvdtest.cvdComposition;
        this.totalItems = response.data.data.cvdtest.length;
        this.testID = response.data.data.cvdtest.ID;
        this.testName = response.data.data.cvdtest.name;
        this.sampleID = response.data.data.cvdtest.sampleID;
        this.saturationPressure = response.data.data.cvdtest.saturationPressure;
        this.saturationPressure_UOM =
          response.data.data.cvdtest.saturationPressure_UOM;
        this.testTemperature = response.data.data.cvdtest.testTemperature;
        this.testTemperature_UOM =
          response.data.data.cvdtest.testTemperature_UOM;
        this.sendDataToParent();

        this.hasStepPressure = this.serverItems.some(item => item.hasOwnProperty('stepPressure'));

        const allKeys = new Set();

        this.serverItems.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (key !== "ID" && key !== "sampleID" && key !== "sortBy" && key !== "sortByMass" && key !== "sortByMole" && !key.endsWith("_UOM")) {
              allKeys.add(key);
            }
          });
        });




        this.variables = Array.from(allKeys).filter(
          (key) => key !== "stepPressure"
        );

        const allUniqueKeys = Array.from(allKeys);

        const displayNames = [];

        await Promise.all(allUniqueKeys.map(async (key) => {
          const capitalizedKey = key.charAt(0) + key.slice(1);
          const displayName = await this.$store.dispatch('metaData/getDisplayName', { tableName: "cvdtests", fieldName: capitalizedKey });
          displayNames.push(displayName);
        }));

        this.headers = Array.from(allKeys).map((key, index) => {
          const uom = this.serverItems.find((item) => item[key + "_UOM"]);
          const name = displayNames[index];
          let unit = uom ? uom[key + "_UOM"] : '-';
          if (!unit || unit === "data-not-available") {
            unit = "-";
          }
          return {
            key: key,
            name: name,
            unit: unit,
          };
        });

        return response.data.data.cvdtest;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    downloadChartCSV(index) {
      const chartData = this.chartData[index];

      if (chartData) {
        const fileName = `${chartData.layout.yaxis.title.text} vs ${chartData.layout.xaxis.title.text} data.csv`;

        const csvHeader = [
          chartData.layout.xaxis.title.text,
          chartData.layout.yaxis.title.text,
        ];

        const csvRows = chartData.trace.x.map((xValue, i) => [
          xValue,
          chartData.trace.y[i],
        ]);

        const csvContent = [
          csvHeader.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      }
    },

    async plotChartForVariable(variable, chartIndex, cvdtest) {
      if (!cvdtest) {
        console.error("No data provided for plotting chart.");
        return;
      }

      const stepPressures = cvdtest.cvdComposition.map(
        (step) => step.stepPressure
      );

      const trace = {
        x: stepPressures,
        y: cvdtest.cvdComposition.map((step) => step[variable]),
        type: "scatter",
        mode: "lines+markers",
        name: variable,
        line: {
          color: "#2199A8",
          width: 2
        },
        marker: {
          color: "#2199A8",
          size: 8,
          line: {
            color: "#2199A8",
            width: 1
          }
        }
      };

      const layout = {
        xaxis: { title: "Pressure (psia)",
          gridcolor: chartGridColor(this.isDarkMode),
        },
        yaxis: {
          title: {
            text: this.getHeaderDisplayName(variable),
            standoff: 20
          },
          type: this.yAxisScales[variable] || "linear",
          automargin: true,
          gridcolor: chartGridColor(this.isDarkMode),
        },
      };
      const config = {
        responsive: true,
        displaylogo: false,
        modeBarButtonsToRemove: ["lasso2d", "select2d", "pan2d", "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Download CSV",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV.bind(this, chartIndex),
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG.bind(this, chartIndex),
          },
          {
            name: "Expand",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${Expand}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.openModal.bind(this, chartIndex),
          },
        ],
      };

      this.chartData[chartIndex] = {
        trace: trace,
        layout: layout,
        config: config,
      };

      const chartRef = this.$refs["chart-" + chartIndex];
      if (chartRef && chartRef.length > 0) {
        const chartElement = chartRef[0];
        Plotly.newPlot(chartElement, [trace], layout, config);
      } else {
        return
      }
    },

    getHeaderDisplayName(variable) {
      const header = this.headers.find(header => header.key === variable);
      if (header) {
        return header.unit !== '-' ? `${header.name} (${header.unit})` : header.name;
      }
      return variable;
    },
    getHeaderDisplayNameChartTitle(variable) {
      const header = this.headers.find(header => header.key === variable);
      if (header) {
        return header.name;
      }
      return variable;
    },

    displayValue(key, value) {
      const header = this.headers.find(header => header.key === key);
      const digits = header ? header.digits : 0; // Get digits from header

      if (value !== null && value !== undefined) {
        if (typeof value === 'string') {
          return value;
        } else {
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            return digits > 0 ? numValue.toFixed(digits) : value;
          }
        }
      } else {
        return "-";
      }
    },

    handleDownloadCSV(chartIndex) {
      this.downloadChartCSV(chartIndex);
    },

    handleDownloadPNG(chartIndex) {
      this.downloadChartPNG(chartIndex);
    },

    downloadChartPNG(index) {
      const chartElement = this.$refs[`chart-${index}`];
      if (!chartElement?.[0]) return;
      const chartData = this.chartData[index];
      const fileName = chartData
        ? `${chartData.layout.yaxis.title.text} vs ${chartData.layout.xaxis.title.text}`
        : `Chart ${index}`;
      downloadPlotlyAsPng([chartData.trace], chartData.layout, fileName, {
        isDarkMode: this.isDarkMode,
        title: fileName,
      });
    },

    openModal(index) {
      this.isPreviewOpen[index] = true;
      this.$nextTick(() => {
        this.plotModalChart(index);
      });
    },
    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },
    plotModalChart(index) {
      const chartData = this.chartData[index];
      if (chartData) {
        const modalChartRef = this.$refs[`modal-chart-${index}`][0];
        Plotly.newPlot(
          modalChartRef,
          [chartData.trace],
          chartData.layout,
          chartData.config
        );
      }
    },
    sendDataToParent() {
      this.$emit("data-updated", {
        testID: this.testID,
        testName: this.testName,
        sampleID: this.sampleID,
        saturationPressure: this.saturationPressure,
        saturationPressure_UOM: this.saturationPressure_UOM,
        testTemperature: this.testTemperature,
        testTemperature_UOM: this.testTemperature_UOM,
      });
    },
    downloadTableCSV() {
      if (this.serverItems && this.serverItems.length > 0) {
        const fileName = `constant_volume_depletion_gas_properties.csv`;

        const csvHeader = this.headers.map((header) => header.name);
        const csvUnits = this.headers.map((header) => header.unit);

        const csvRows = this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        );

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },
  },
  watch: {
    $route(to, from) {
      this.loadItems()
        .then((ccetest) => {
          this.variables.forEach((variable, index) => {
            this.plotChartForVariable(variable, index, ccetest);
          });
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },
    isDarkMode() {
      this.loadItems().then((cvdtest) => {
        this.variables.forEach((variable, index) => {
          this.plotChartForVariable(variable, index, cvdtest);
        });
      });
    }
  },
  mounted() {
    this.loadItems().then((cvdtest) => {
      this.variables.forEach((variable, index) => {
        this.plotChartForVariable(variable, index, cvdtest);
      });
    });
  },
};
</script>